import {
  Component,
  OnInit
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CategoryService } from 'src/app/api/catalog/category.service';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';

@Component({
  selector: 'app-category-form',
  templateUrl: './category-form.component.html',
  styleUrls: ['./category-form.component.css']
})
export class CategoryFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      description_content: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;      
    }
  }

  ngOnInit() {
    if (this.isEdit) {
      this.editData();
    }
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.categoryService.get(this.checkId).subscribe({
      next: (data: any) => {
        this.item.setValue({
          description: data.data.description,
          description_content: data.data.description_content
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.categoryService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/catalogo/categorias/lista'
            ]);
          }
        });
      } else {
        this.categoryService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/catalogo/categorias/lista'
            ]);
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/catalogo/categorias/lista'
    ]);
  }
}
